import type { IGlyphShape } from './IGlyphShape';
import type { ToolbarGlyphName } from './ToolbarGlyphName';

const path = (d: string): IGlyphShape => ({ tag: 'path', attrs: { d } });
const rect = (x: string, y: string, width: string, height: string, rx: string): IGlyphShape => ({ tag: 'rect', attrs: { x, y, width, height, rx } });
const GEAR = 'M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 '
  + '1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 '
  + '2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 '
  + '1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z';

/**
 * Знаки панелі списку — ті самі контури, що вбудовані в розмітку прототипу v4 (кнопки editSelected, copySelected, deleteSelected,
 * exportSmart, printList, resetFilters, editDefinition): перо з рискою, менші копія й принтер, кошик, стрілка до лінії, поворот, шестерня.
 */
export const toolbarGlyphs: Record<ToolbarGlyphName, IGlyphShape[]> = {
  edit: [path('M12 20h9'), path('M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z')],
  copy: [rect('9', '9', '11', '11', '2'), path('M5 15V5a2 2 0 0 1 2-2h8')],
  delete: [path('M4 7h16'), path('M10 11v6'), path('M14 11v6'), path('M6 7l1 13h10l1-13'), path('M9 7V4h6v3')],
  export: [path('M12 3v12'), path('m7 10 5 5 5-5'), path('M5 21h14')],
  print: [path('M7 9V4h10v5'), rect('4', '9', '16', '8', '2'), path('M8 17v3h8v-3')],
  reset: [path('M3 12a9 9 0 1 0 3-6.7'), path('M3 4v5h5')],
  definition: [{ tag: 'circle', attrs: { cx: '12', cy: '12', r: '3' } }, path(GEAR)],
};
